import { Component, OnInit } from '@angular/core';
import {StateService} from '../../../core/service';
import {LanguagesService} from '../../../core/service';

@Component({
  selector: 'gc-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.less']
})
export class BackButtonComponent implements OnInit {
  constructor(public lang: LanguagesService, public state: StateService) { }

  ngOnInit(): void {

  }

  backward(): void {
    this.state.backward();
  }
}
